import React from "react";
import { FiPlus } from "react-icons/fi";

const AddOptionsButton = ({
  showOptions,
  setShowOptions,
  addOptionsRef,
  onAddManual,
  fileInputRef,
  handleFileChange,
  onShowInstructions,
  buttonLabel = "Add",
  buttonTitle = "Add",
  manualLabel = "Add Manually",
  FileUploadButtonComponent,
  className = "",
}) => (
  <div className={`relative ${className}`}>
    <button
      onClick={() => setShowOptions((prev) => !prev)}
      className="flex items-center gap-2 bg-btn-primary text-white px-4 py-3 rounded-full shadow-lg hover:bg-btn-primary-hover transition-colors"
      title={buttonTitle}
      type="button"
    >
      <FiPlus className="text-sm" />
      <span className="hidden sm:inline">{buttonLabel}</span>
    </button>
    {showOptions && (
      <div
        ref={addOptionsRef}
        className="absolute top-full mt-2 right-0 bg-white border rounded-lg shadow-lg z-50 min-w-[140px] w-max"
        style={{ maxWidth: "90vw" }}
      >
        <button
          className="flex items-center w-full px-2 py-1 text-xs sm:px-4 sm:py-2 sm:text-sm hover:bg-gray-50 text-gray-700"
          onClick={() => {
            onAddManual();
            setShowOptions(false);
          }}
          type="button"
        >
          <FiPlus className="mr-2 text-base sm:text-lg" /> {manualLabel}
        </button>
        {FileUploadButtonComponent && (
          <FileUploadButtonComponent
            onClick={handleFileChange}
            fileInputRef={fileInputRef}
            accept=".csv,.json,.pdf,.xls,.xlsx"
            onShowInstructions={onShowInstructions}
            className="px-2 py-1 text-xs sm:px-4 sm:py-2 sm:text-sm"
          />
        )}
      </div>
    )}
  </div>
);

export default AddOptionsButton;